'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX modules
import DeliveryOptionIcon from './delivery-option-icon';
import CartItemsChangeEvents from '../../_cart/cart-items-change-events';
import { builderDispatch } from '../ui';

let ids = 0;
function generateId() {
  return `delivery-option-radios-${ids++}`;
}

// -----------------------------------------------------------
//  DeliveryOptionsForm
// -----------------------------------------------------------
class DeliveryOptionsForm extends React.PureComponent {
  static propTypes = {
    hideIcon: PropTypes.bool,
    itemId: PropTypes.number,
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.number.isRequired,
    horizontalLayout: PropTypes.bool,
  };

  static defaultProps = {
    horizontalLayout: false,
  };

  constructor(props) {
    super(props);
    this.inputName = generateId();
  }

  render() {
    const {
      options,
      selectedOption,
      itemId = '',
      hideIcon,
      horizontalLayout,
    } = this.props;

    return (
      <div className="delivery-options">
        {horizontalLayout ? (
          <fieldset
            className="delivery-options__horizontal d-flex justify-content-center my-2"
            aria-label="Delivery Options">
            <legend className="sr-only">Choose a Delivery Option</legend>
            {options.map((option) => {
              const id = `delivery-option-${itemId}-${option.key}`;
              const optionTypeClassname = `delivery-options__horizontal__${option.type.toLowerCase()}`;
              const selected = selectedOption == option.key;

              return (
                <label
                  key={id}
                  className={`delivery-options__horizontal__option text-center${selected ? ' selected' : ''}`}>
                  <input
                    id={id}
                    checked={selected}
                    name={this.inputName}
                    type="radio"
                    value={option.key}
                    onChange={() => this.handleChange(option)}
                  />
                  <span
                    className={`delivery-options__horizontal__icon ${optionTypeClassname}`}
                    aria-hidden="true"></span>
                  <div>{option.mobile_title || option.title}</div>
                </label>
              );
            })}
          </fieldset>
        ) : (
          options.map((option) => {
            const id = `delivery-option-${itemId}-${option.key}`;

            return (
              <div
                key={id}
                className="delivery-option form-check available"
                data-type={option.type}>
                <input
                  id={id}
                  name={this.inputName}
                  checked={selectedOption == option.key}
                  className="form-check-input"
                  type="radio"
                  value={option.key}
                  onChange={() => this.handleChange(option)}
                />
                <label className="form-check-label" htmlFor={id}>
                  <DeliveryOptionIcon option={option} hideIcon={hideIcon} />
                </label>
              </div>
            );
          })
        )}
      </div>
    );
  }

  handleChange({ key: optionId }) {
    builderDispatch.dispatch({
      type: CartItemsChangeEvents.DELIVERY_OPTION_CHANGE,
      optionId,
      itemId: this.props.itemId,
    });
  }
}

DeliveryOptionsForm.displayName = 'Delivery Options Form';

export default DeliveryOptionsForm;
